import { generalHelpers } from '@tweddle-se-team/common/helpers'
import axios from 'axios'
import { stringify } from 'qs'
import { getCookieValue } from '../auth'
import { apiUrlSsr } from '../env'

const isServer = generalHelpers.isServer()

const createAnonymousAxiosInstance = () => {
  if (!isServer && !window.RUNTIME_CONFIG.apiUrlClient)
    throw new Error('RUNTIME_CONFIG.apiUrlClient is not defined. Please check your environment configuration.')
  const anonymousAxiosInstance = axios.create({
    baseURL: isServer ? apiUrlSsr : window.RUNTIME_CONFIG.apiUrlClient,
    headers: {}
  })

  // This response interceptor is used to return only the data from the response
  anonymousAxiosInstance.interceptors.response.use(res => res.data)
  return anonymousAxiosInstance
}

// Create an axios instance
const createAuthenticatedAxiosInstance = ctx => {
  const jwt = getCookieValue(ctx, 'jwt')
  // const refreshToken = getCookieValue(ctx, "refreshToken");
  // console.log("JWT from context:", jwt);

  if (!isServer)
    throw new Error('Axios instance can only be used on the Server. For client side requests use useApi hook')

  const instance = axios.create({
    baseURL: apiUrlSsr,
    headers: {
      'Content-Type': 'application/json',
      ...(jwt && { Authorization: `Bearer ${jwt}` })
    },
    withCredentials: true
  })

  // @TODO: Uncomment this if you want to handle token refresh on the server side automatically
  // instance.interceptors.response.use(
  //   (response) => response,
  //   async (error) => {
  //     const originalRequest = error.config;

  //     if (
  //       error.response?.status === 401 &&
  //       !originalRequest._retry &&
  //       refreshToken
  //     ) {
  //       originalRequest._retry = true;

  //       try {
  //         // Call your own Next.js proxy API to refresh the token using cookies
  //         const refreshResponse = await axios.post(
  //           `${apiUrlSsr}/auth/refresh`,
  //           {
  //             refreshToken,
  //           }
  //         );

  //         const { jwt } = refreshResponse.data;

  //         // Update headers for original and future requests
  //         originalRequest.headers.Authorization = `Bearer ${jwt}`;
  //         instance.defaults.headers.Authorization = `Bearer ${jwt}`;

  //         console.log("Token refreshed successfully by Interceptor:", jwt);

  //         return instance(originalRequest);
  //       } catch (refreshError) {
  //         console.error("Token refresh failed on SSR:", refreshError);
  //         throw refreshError;
  //       }
  //     }

  //     return Promise.reject(error);
  //   }
  // );

  instance.interceptors.response.use(res => res.data)

  return instance
}

// Export helper methods
const apiWrapper = {
  get: async (url, query = {}, ctx) => {
    const queryString = query ? `?${stringify(query)}` : ''
    return ctx
      ? createAuthenticatedAxiosInstance(ctx).get(`${url}${queryString}`)
      : createAnonymousAxiosInstance().get(`${url}${queryString}`)
  },
  post: async (url, data = {}, ctx) =>
    ctx ? createAuthenticatedAxiosInstance(ctx).post(url, data) : createAnonymousAxiosInstance().post(url, data),

  put: async (url, data = {}, ctx) =>
    ctx ? createAuthenticatedAxiosInstance(ctx).put(url, data) : createAnonymousAxiosInstance().put(url, data),

  patch: async (url, data = {}, ctx) =>
    ctx ? createAuthenticatedAxiosInstance(ctx).patch(url, data) : createAnonymousAxiosInstance().patch(url, data),

  delete: async (url, data = {}, ctx) =>
    ctx ? createAuthenticatedAxiosInstance(ctx).delete(url, data) : createAnonymousAxiosInstance().delete(url, data),

  getHeaders: ctx => {
    if (!ctx) return {}
    const jwt = getCookieValue(ctx, 'jwt')
    return {
      headers: {
        ...(jwt && { Authorization: `Bearer ${jwt}` })
      }
    }
  }
}

export default apiWrapper
